import React, {useState} from "react";
import moment from 'moment';
import './withdrawal.scss';

import Button from '../../../Form/Button/Button';
import {LoadingButton} from '../../../Form/Button/Button';
import ButtonGroup from '../../../Form/Button/ButtonGroup';
import CurrencyInput from '../../../Form/TextInput/CurrencyInput';
import TextInput from '../../../Form/TextInput/TextInput';
import {formatCurrency} from '../../../../utils/helpers';
import withFeatureFlags from '../../../FeatureFlags/withFeatureFlags';
import {CustomSelect} from '../../../Form/Select/Select';
import {useLogger} from "../../../../contexts/Logger";
import {productTypes} from "../../../../utils/productHelpers";
import Modal from "../../../Modal/Modal";

/** @import { WithFeatureFlagsProps } from "../../../FeatureFlags/FeatureFlagsTypes" */
/** @import { FirstStepProps } from "./FirstStepTypes" */
/** @import {NoticePeriod} from './indexTypes' */
/** @import {DestinationAccount} from "../../../MyAccount/MyAccountTypes" */

import rightArrow from '../../../../assets/images/arrow-right.svg'
import {useUnifiedAnalytics} from "../../../../contexts/AnalyticsWrapper";

function FirstStep(/** @type {WithFeatureFlagsProps & FirstStepProps} */ props) {
    const {
        accounts,
        interestPaid,
        noticePeriod,
        onCancel,
        onConfirm,
        onCloseAccount,
        onKeepAccount,
        onAmountChange,
        onAccountSelected,
        balance,
        availableBalance,
        maxWithdrawalLimit,
        lowerInterestRateAmount,
        productName,
        stepUpAmount,
        isNoticeWithdrawal,
        isIsaWithdrawal,
        featureEnabled,
        error,
        loading,
        enableClosure
    } = props;

    const logger = useLogger();
    const analytics = useUnifiedAnalytics();

    const [showReview, setShowReview] = useState(false);
    const [showClosure, setShowClosure] = useState('init');
    const [showModal, setShowModal] = useState(false);
    const [amount, setAmount] = useState(/** @type {number | null} */ (null));
    const [reference, setReference] = useState(/** @type {string | null} */ (null));

    const [selectedDestinationAccount, setSelectedDestinationAccount] = useState(/** @type {DestinationAccount | null} */ (null));

    const keepMyAccountButtonLabel = 'Keep my account';

    const shouldStepUp = () => amount && stepUpAmount && amount >= stepUpAmount;

    const onReviewClicked =  async (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event, /** @type {string} */ buttonLabel) => {
        event.preventDefault();

        if (!selectedDestinationAccount) return;
        if (isNoticeWithdrawal) {
            if (buttonLabel === keepMyAccountButtonLabel) {
                analytics.trackAnalyticsPopupClick(
                    'Keep my account',
                    'click',
                    'keeping ns account',
                    '',
                    'account|click|keeping ns account'
                );
            }
            else {
                analytics.trackAnalyticsClickEvent(
                    'confirm',
                    window.location.href,
                    'dashboard',
                    'notice-saver',
                    'ns withdrawal journey',
                    {
                        "accountType": selectedDestinationAccount.productName
                    },
                    'link click',
                    'dashboard|click|ns-confirm',
                    'dashbaord'
                );

            }
        }
        setShowReview(true);
        setShowClosure('done');
        setShowModal(false);
        return false;
    };

    const onKeepAccountClicked = async (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();

        if (!selectedDestinationAccount) return;
        if (isNoticeWithdrawal) {
            analytics.trackAnalyticsClickEvent(
                'keep my ns account',
                window.location.href,
                'dashboard',
                'notice-saver',
                'ns withdrawal journey',
                {},
                'link click',
                'account|keep|ns keep',
                'ns withdrawal journey'
            );

            analytics.trackAnalyticsPopupClick(
                'Keep my account',
                'view',
                'keeping ns account',
                'ns withdrawal journey',
                'account|view|keeping ns account'
            );

        }
        if (typeof onKeepAccount === 'function') onKeepAccount('keep');
        setShowModal(true);
        return false;
    };

    const onCheckClosureClicked = async (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();

        if (!selectedDestinationAccount) return;
        if (isNoticeWithdrawal) {            
            analytics.trackAnalyticsClickEvent(
                'confirm full',
                window.location.href,
                'dashboard',
                'notice-saver',
                'ns withdrawal journey',
                {
                    "accountType": selectedDestinationAccount.productName
                },
                'link click',
                'transaction|confirm full|ns withdrawal',
                'ns withdrawal journey'
            );

        }
        setShowClosure('show');
        return false;
    };

    const onConfirmClicked = async (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event, isFullWithdrawAndKeep = false) => {
        event.preventDefault();
        if (!selectedDestinationAccount) return;
        if (isNoticeWithdrawal) {
            if (event.target instanceof HTMLElement && event.target.textContent === keepMyAccountButtonLabel){
                analytics.trackAnalyticsPopupClick(
                    'Keep my account',
                    'click',
                    'closing ns account',
                    'ns withdrawal journey',
                    'account|click|closing ns account'
                );
            }
            else if (isFullWithdrawAndKeep) {
                analytics.trackAnalyticsClickEvent(
                    'confirm keep',
                    window.location.href,
                    '',
                    'notice-saver',
                    '',
                    {
                        "accountType": selectedDestinationAccount.productName
                    },
                    'link click',
                    'dashboard|click|confirm',
                    'dashboard'
                );

            }
            else{
                analytics.trackAnalyticsClickEvent(
                    'confirm partial',
                    window.location.href,
                    'dashboard',
                    'notice-saver',
                    '',
                    {
                        "accountType": selectedDestinationAccount.productName
                    },
                    '',
                    'dashboard|click|confirm',
                    'dashboard'
                );

            }
        }
        else{
            analytics.trackAnalyticsClickEvent(
                'confirm partial',
                window.location.href,
                'dashboard',
                'online-flexi-saver',
                '',
                {
                    "accountType": selectedDestinationAccount.productName
                },
                '',
                'dashboard|click|confirm',
                'dashboard'
            );
        }
        if (typeof onConfirm === 'function') onConfirm(event);
        return false;
    };

    const onCancelClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();
        if (typeof onCancel === 'function') onCancel(event);
        return false;
    };

    const onCloseAccountClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();

        if (!selectedDestinationAccount) return;
        if (isNoticeWithdrawal) {            
            analytics.trackAnalyticsClickEvent(
                'close my ns account',
                window.location.href,
                'dashboard',
                'notice-saver',
                'ns withdrawal journey',
                {},
                'link click',
                'account|close|ns closure',
                'ns withdrawal journey'
            );

        }

        if (typeof onCloseAccount === 'function') onCloseAccount(event, selectedDestinationAccount.accountNumber);
        return false;
    };

    const onAmountInputChanged = (/** @type {string} */ amount) => {
        let val = parseFloat(amount.replace(/,/g, ''));
        setAmount(val);
        if (typeof onAmountChange === 'function') onAmountChange(val);
        return false;
    };

    const onReferenceInputChanged = (/** @type {string} */ reference) => {
        setReference(reference);
    };

    const onSelectedAccountChanged = (/** @type {string} */ accountNumber) => {
        let selected = accounts.find(a => a.accountNumber === accountNumber);
        if (selected == null) return;
        setSelectedDestinationAccount(selected);
        if (typeof onAccountSelected === 'function') onAccountSelected(selected);
    };

    const isValidAmount = () => {
        if (isNoticeWithdrawal) {
            return amount && !isAmountMoreThanBalance() && !isAmountMoreThanWithdrawalLimit();
        }

        return amount && !isAmountMoreThanBalance() && !isAmountMoreThanWithdrawalLimit() && !isAmountExceedingWithdrawalAccountLimit();
    };

    const isAmountMoreThanBalance = () => {
        if (isNoticeWithdrawal && amount) {
            return Number((availableBalance - amount).toFixed(2)) < 0;
        }

        return Number((balance - (amount || 0)).toFixed(2)) < 0;
    };

    const isAmountMoreThanWithdrawalLimit = () => {
        return amount && maxWithdrawalLimit ? amount > maxWithdrawalLimit : false;
    };

    const isAmountExceedingWithdrawalAccountLimit = () => {
        if (!selectedDestinationAccount || amount == null) {
            return false;
        }
        const maximumBalance = getDestinationMaximumBalance();
        return maximumBalance != null && amount > getMaxWithdrawalAccountLimit();
    }

    const getDestinationMaximumBalance = () => {
        if (!selectedDestinationAccount || selectedDestinationAccount.isExternalAccount) {
            return null;
        }

        return selectedDestinationAccount.maxWithdrawalLimit ?? null;
    };

    const getMaxWithdrawalAccountLimit = () => {
        const maximumBalance = getDestinationMaximumBalance();
        if (!selectedDestinationAccount || maximumBalance == null) {
            return 0;
        }

        const destinationBalance = selectedDestinationAccount.balance ?? 0;

        return Math.max(0, maximumBalance - destinationBalance);
    }


    const calculatePaymentDate = (/** @type {NoticePeriod} */ noticePeriod, /** @type {boolean} */ longFormat) => {
        let d = moment()
        if (noticePeriod && noticePeriod.length && noticePeriod.length > 0 && noticePeriod.unit) {
            d.add(noticePeriod.length, /** @type {any} */ (noticePeriod.unit));
        }
        return d.format(longFormat ? "D MMMM YYYY" : "DD/MM/YY")
    }

    const withdrawalReducesInterest = () => {
        const tierThreshold = lowerInterestRateAmount;
        if (isNoticeWithdrawal && amount) {
            // @ts-expect-error unsure what this is support to do - discuss with Brad
            return availableBalance >= tierThreshold && (availableBalance - amount).toFixed(2) < tierThreshold;
        }
        // @ts-expect-error unsure what this is support to do - discuss with Brad
        return balance >= tierThreshold && (balance - amount).toFixed(2) < tierThreshold;
    };

    const selectorAccounts = accounts.map(a => {
        return {
            label: a.label,
            value: a.accountNumber
        }
    });

    const renderBalanceError = () => {
        if (!isNoticeWithdrawal && selectedDestinationAccount && !selectedDestinationAccount.isExternalAccount && isAmountExceedingWithdrawalAccountLimit()) {
            return `You can deposit up to ${formatCurrency(getMaxWithdrawalAccountLimit())} before you reach your ${selectedDestinationAccount.productName}'s maximum balance`;
        }

        if (isAmountMoreThanBalance()) {
            if (isNoticeWithdrawal) {
                return `You have up to ${formatCurrency(availableBalance)} available to withdraw`;
            }
            return `You have up to ${formatCurrency(balance)} available to withdraw`;
        }

        if (isAmountMoreThanWithdrawalLimit()) {
            return `Max of ${maxWithdrawalLimit ? formatCurrency(maxWithdrawalLimit) : ''} allowed for each withdraw`;
        }

        if (withdrawalReducesInterest() && !isNoticeWithdrawal) {
            return (<span className="withdrawal__error--warning">
                This will reduce your {productName} balance to below {lowerInterestRateAmount ? formatCurrency(lowerInterestRateAmount) : ''}, which means you'll stop earning any interest
            </span>);
        }

        if (withdrawalReducesInterest() && isNoticeWithdrawal) {
            return (<span className="withdrawal__error--warning">
                This withdrawal will reduce your balance to less than £5,000 in 90 days' time, at which point you'll stop earning any interest
            </span>);
        }
    }

    const renderTransferSummary = (/** @type {DestinationAccount} */ selectedDestinationAccount, /** @type {boolean} */ includeName) => {
        if (!selectedDestinationAccount) return (<></>);
        return (<>
            {includeName && <div className="withdrawal__line">{selectedDestinationAccount.productName}</div>}
            <div className="withdrawal__line">Account no. {selectedDestinationAccount.accountNumber}</div>
            <div
                className="withdrawal__line">Balance {selectedDestinationAccount.balance ? formatCurrency(selectedDestinationAccount.balance) : "-"}</div>
        </>);
    }

    const renderLinkedAccountSummary = (/** @type {DestinationAccount} */ selectedDestinationAccount, /** @type {boolean} */ includeName) => {
        return (<>
            {includeName && <div className="withdrawal__line">Linked Account</div>}
            <div className="withdrawal__line">Account
                no. {selectedDestinationAccount ? selectedDestinationAccount.accountNumber : "-"}</div>
            <div className="withdrawal__line">Sort
                code: {selectedDestinationAccount ? selectedDestinationAccount.sortCode : "-"}</div>
        </>);
    }

    const isTransfer = () => {
        return !!selectedDestinationAccount?.productType;
    }

    const renderConfirmButton = (/** @type {string} */ label) => {
        if (loading) {
            return (<LoadingButton size='med' />);
        }

        let disabled = !isValidAmount() || !selectedDestinationAccount;
        label = label || (isNoticeWithdrawal || shouldStepUp() ? "Confirm" : "Send");

        let action = onConfirmClicked;

        if(amount === availableBalance){
            action = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => onConfirmClicked(event, true);
        }

        if (!showReview && (isTransferToFixedTermAccount() || (isTransfer() && isNoticeWithdrawal))) {
            action = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => onReviewClicked(event, label);
        }

        if (showClosure === 'init' && amount && amount >= availableBalance && enableClosure) {
            action = onCheckClosureClicked;
        }

        return (<Button
                size='med'
                label={label}
                onClick={action}
                disabled={disabled} />
        );
    };

    const isTransferToFixedTermAccount = () => {
        return selectedDestinationAccount?.productType === productTypes.FixedTerm;
    }

    const renderScheduledTransferWarning = () => {
        return (
            <div className={"withdrawal__review-warning"}>If your {selectedDestinationAccount?.productName} is closed or
                full, we'll make this payment into your linked account instead.</div>)
    }

    const renderTransferToFixedWarning = () => {
        return (
            <div className={"withdrawal__review-warning"}>Don't forget you wont be able to access this money again until
                your term ends.</div>)
    }

    const renderAmountEntry = () => {
        let balanceError = renderBalanceError();

        return (<>
            <div className="withdrawal__input">
                <CurrencyInput
                    onChange={onAmountInputChanged}
                    placeholder="Amount"
                    //@ts-expect-error there is no disabled property on CurrencyInput
                    disabled={!selectedDestinationAccount}
                />
                {featureEnabled('EnableWithdrawalReferences') && (<TextInput
                    onChange={onReferenceInputChanged}
                    className="reference__input"
                    placeholder="Reference"
                />)}
            </div>

            <div className={"withdrawal__feedback"}>
                {error && (<div className={"withdrawal__error withdrawal__error--show"}>{error.message}</div>)}
                {!error && balanceError && (
                    <div className={"withdrawal__error withdrawal__error--show"}>{balanceError}</div>)}
                {!error && !balanceError && isIsaWithdrawal && amount > 0 && (
                    <div className="withdrawal__error withdrawal__error--show withdrawal__error--warning">Money you withdraw will lose its tax-free status</div>)}
                {!error && !balanceError && isNoticeWithdrawal && (
                    <div className="withdrawal__text withdrawal__text--show">You should see this money in your account
                        on {noticePeriod ? calculatePaymentDate(noticePeriod, true) : ''}.</div>)}
            </div>
        </>);
    }

    const renderInterestPayoutInformation = () => {
        const getInterestPaidToCopy = () => {
            if (interestPaid === "online_flexi_saver"){
                return "Online Flexi Saver"
            }
            if (interestPaid === "flexi_saver"){
                return "Fixed Rate Saver"
            }
            if (interestPaid === "notice_saver"){
                return "Notice Saver"
            }
            return "linked account"
        }

        return (<Modal onClose={() => 
        { 
            setShowModal(false);
            analytics.trackAnalyticsPopupClick(
                'close',
                'click',
                'closing ns account',
                'ns withdrawal journey',
                'account|click|closing ns account'
            );
        }} className='modal--wide apply-layout__close-modal close-modal'>
            <p className="modal__title">Keeping your 90-Day Notice Saver</p>
            <div className='modal__paragraph'>
                <p>Please note the amount you've decided to withdraw won't include any interest you'll earn during your notice period. This will be paid out to your {getInterestPaidToCopy()} on the 15th of each month as usual. You'll need to close your account if you'd like it included in your withdrawal.</p>
                <br/>
                <p>To continue, select 'Keep my account' below.</p>
                <br/>
                <ButtonGroup noGutter className={'button-group--mobile-friendly'}>
                    <Button variant='secondary' size='med' label='Go back' onClick={() => {
                        setShowModal(false);                        
                        analytics.trackAnalyticsPopupClick(
                            'Go back',
                            'click',
                            'closing ns account',
                            'ns withdrawal journey',
                            'navigation|click|closing ns account'
                        );

                    }} />
                    {renderConfirmButton(keepMyAccountButtonLabel)}
                </ButtonGroup>
            </div>
            <div className="modal__spacer"/>
        </Modal>)
    }

    const renderClosureCheck = () => {
        return (
            <div className="withdrawal__section--horizontal-full">
                <div className="withdrawal__closure-message">You’re withdrawing your full balance – would you also like to close your account?</div>
                <div className="withdrawal__actions">
                    <ButtonGroup noGutter>
                        <Button variant='secondary' size='med' type="button" label="Close my account"
                                onClick={onCloseAccountClicked} disabled={loading}/>
                        <Button size='med' type="button" label="Keep my account"
                                onClick={onKeepAccountClicked} disabled={loading}/>
                    </ButtonGroup>
                </div>
            </div>)
    }

    const renderSummaryAndConfirm = () => {
        return (<>
            <div className="withdrawal__section">
                <div className="withdrawal__destination-selector">
                    <img src={rightArrow} className="withdrawal__destination-selector__arrow" />
                    <div className="withdrawal__destination-selector__title">To</div>
                    <div className="withdrawal__destination-selector__box">
                        <CustomSelect
                            name='account'
                            placeholder='Select an account'
                            options={selectorAccounts}
                            onChange={option => option ? onSelectedAccountChanged(option.value) : null}
                            disabled={showReview}
                            customClassNames={["withdrawal__selector"]}
                        />
                    </div>
                </div>
                {selectedDestinationAccount && selectedDestinationAccount.productType && renderTransferSummary(selectedDestinationAccount, showReview)}
                {selectedDestinationAccount && !selectedDestinationAccount.productType && renderLinkedAccountSummary(selectedDestinationAccount, showReview)}
            </div>
            <div className="withdrawal__divider"/>
            <div className="withdrawal__section-bigger">
                {showReview && isTransferToFixedTermAccount() && renderTransferToFixedWarning()}
                {showReview && isNoticeWithdrawal && isTransfer() && renderScheduledTransferWarning()}
                {!showReview && renderAmountEntry()}
                <div className="withdrawal__section--horizontal">
                    <div className="withdrawal__actions">
                        <ButtonGroup noGutter>
                            {renderConfirmButton()}
                            <Button variant='secondary' size='med' type="button" label="Cancel"
                                    onClick={onCancelClicked} disabled={loading}/>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        </>)
    }

    return (
        <form className="withdrawal withdrawal--step-1">
            <div className="withdrawal__section">
                <h3 className="withdrawal__title">Withdrawal</h3>
                <div className="withdrawal__product">
                    <span className="withdrawal__product-key">From</span>
                    <span className="withdrawal__product-value">{productName}</span>
                </div>
                <div className="withdrawal__balance">
                    <span className="withdrawal__balance-key">{isNoticeWithdrawal ? "Available balance" : "Balance"}</span>
                    <span className="withdrawal__balance-value">{isNoticeWithdrawal ? formatCurrency(availableBalance) : formatCurrency(balance)}</span>
                </div>
            </div>
            <div className="withdrawal__divider"/>
            {showClosure === 'show' && renderClosureCheck()}
            {showClosure !== 'show' && renderSummaryAndConfirm()}
            {showModal && renderInterestPayoutInformation()}
        </form>
    );
}

export default withFeatureFlags(FirstStep);
